const escapeHtml = (value: string) =>
  value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")

// Single source of truth for the default email signature content (logo only, 28px), shared by the
// backend (outbound emails) and the frontend editor preview. The separator line is added around
// any signature — default or custom — by renderEmailMessage, not here.
export const buildDefaultEmailSignatureHtml = ({ logo }: { logo?: string | null }) =>
  logo
    ? `<img src="${escapeHtml(logo)}" height="28" alt="" style="display:block;height:28px;width:auto" />`
    : ""
